<template>
  <section class="patch-notes">
    <CommonPatchNoteBanner v-bind="ModulePatchNoteListData" style="z-index: 1" />
    <CommonPatchNoteList :articleList="articleList">
      <div :class="['patch-note', 'load-more', hideLodeMore ? 'hide-load-more' : '']" @click="loadMore">
        {{ formatTransify('UGC_OFFICIAL_WEBSITE_LOAD_MORE') }}
        <IconsMoreArrow class="load-more-icon" />
      </div>
      <div v-if="isLoading" class="loading-status" />
    </CommonPatchNoteList>
  </section>
</template>
<script lang="ts" setup>
import { type Ref } from 'vue'
import { formatTime } from '~/utils'
useRouteCache((route) => {
  route.setCacheable().setMaxAge(300).addTags(['patch-notes-index-page-cache-tag'])
})
const { formatTransify } = useStore()
const { fetchPageData, filterModule } = usePageStore()
await fetchPageData('/patch-notes/')
const ModulePatchNoteListData = filterModule('ModulePatchnoteList')
const { fetchArticleList } = useArticleStore()
const hideLodeMore = ref(true)
const isLoading = ref(false)
const articleList: Ref<any[]> = ref([])
const pagination = ref({ page: 1, size: 5, count: 0 })

const markFirstOccurrence = (items: any[]) => {
  const seenMonths = new Set()
  items.forEach((item: any) => {
    const month = formatTime(item.date).substring(3)
    if (!seenMonths.has(month)) {
      item.firstSeen = true
      seenMonths.add(month)
    } else {
      item.firstSeen = false
    }
  })
}

const getPatchNoteList = async (isRefresh: boolean = false) => {
  isLoading.value = true
  hideLodeMore.value = true
  const result = await fetchArticleList(
    1,
    pagination.value.page,
    pagination.value.size,
    'category',
    ModulePatchNoteListData.category_id
  )
  const articles = result.data
  if (isRefresh) {
    articleList.value = [...articles]
  } else {
    articleList.value = [...articleList.value, ...articles]
  }
  markFirstOccurrence(articleList.value)
  pagination.value.count = result.count
  hideLodeMore.value = pagination.value.count - articleList.value.length <= 0
  isLoading.value = false
}

const loadMore = async () => {
  pagination.value.page++
  await getPatchNoteList()
}

const formatTitle = (title: string) => {
  return title.replace('{style}', '<span style="color: #FFBA00">').replace('{style}', '</span>')
}

const formatDate = (date: number) => {
  return formatTime(date).substring(3).replace('/', ' / ')
}

getPatchNoteList(true)
</script>
<style lang="scss" scoped>
@media screen and (min-width: 1024px) {
  .patch-notes {
    background-image: url('@/assets/images/home-bg.jpg');
    background-size: contain;
    background-position: center top;
    background-repeat-y: repeat;
  }
}

.patch-note {
  &.load-more {
    @apply pt-[52px] flex justify-center items-center uppercase text-[#fff] cursor-pointer text-[14px]/[22px];
    //   hover
    @apply hover:text-[#ffba00];

    // 三角形
    &.hide-load-more {
      opacity: 0;
    }

    .load-more-icon {
      @apply w-[14px] h-[14px] ml-2;
      @apply max-lg:w-4 max-lg:h-4 max-lg:mt-[1px];
    }

    //  mobile
    @apply max-lg:w-full max-lg:pt-0 max-lg:hover:text-[#fff] max-lg:text-[12px]/[18px];
  }

  .loading-status {
    background-image: url('@/assets/images/loading.svg');
    width: 44px;
    height: 44px;
    margin: 0 auto 27px;
  }
}

@media not all and (min-width: 1024px) {
  .patch-note {
    width: 686px;

    &-content {
      width: 100%;
      padding-left: 28px;
      padding-bottom: 28px;

      &-date {
        color: var(--theme-white);
      }

      &-text {
        padding: 14px 0 30px;
        font-size: 24px;
        width: 100%;

        &:deep(h1) {
          font-size: 36px;
          line-height: 50px;
        }

        &:deep(h2) {
          font-size: 34px;
          line-height: 42px;
        }

        &:deep(h3) {
          font-size: 32px;
          line-height: 38px;
        }

        &:deep(h4) {
          font-size: 28px;
          line-height: 32px;
        }

        &:deep(p) {
          font-size: 26px;
          line-height: 32px;
        }

        &:deep(pre code) {
          display: block;
          padding: 24px;
          width: 100%;
          line-height: 1.5;
          font-size: 0.9em;
          color: #a6accd;
          transition: color 0.5s;
          background-color: #323232;
          border-radius: 10px;
          margin: 20px 0;
          white-space: pre;

          span {
            color: #ffba00;
          }
        }

        &:deep(code) {
          font-size: 24px;
        }

        &:deep(iframe) {
          width: 680px;
          height: 382px;
        }
      }
    }
  }

  @media screen and (orientation: landscape) {
    .patch-note {
      width: 85%;
    }
  }
}
</style>
